import { render, staticRenderFns } from "./AxDropzone.vue?vue&type=template&id=6bb3a26b&"
import script from "./AxDropzone.vue?vue&type=script&lang=ts&"
export * from "./AxDropzone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports